import {useContext} from "react";
import {LabReportContext} from "../container/LabReportContext";

const useLabReportContext = () => {
    return useContext(LabReportContext)
}

export default useLabReportContext
